export default __webpack_public_path__ + "static/media/logo.4ce0ed9b.png";